<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-value="id"
                item-text="name"
                menu-props="auto"
                :readonly="checkUserRole() ? true : false"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="qcNo"
                label="QC No"
                type="text"
                v-model="queryParams.qcNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="poNo"
                label="PO No"
                type="text"
                v-model="queryParams.poNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="qcList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-layout>
                  <v-btn
                    flat
                    icon
                    color="blue lighten-2"
                    @click="onEdit(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    flat
                    icon
                    color="blue lighten-2"
                    @click="printDetail(props.item, 'printQCDetail')"
                    :disabled="props.item.status != 'PASS'"
                  >
                    <v-icon>print</v-icon>
                  </v-btn>
                </v-layout>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.qcNo }}</td>
              <td>{{ props.item.purchaseOrderNo }}</td>
              <td>{{ props.item.reference }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- print detail -->
    <div
      id="printQCDetail"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div
        v-if="qc.warehouseLetterHeadUrl"
        style="
          float: left;
          padding-left: 11px;
          padding-top: 10px;
          text-align: center;
        "
      >
        <img :src="qc.warehouseLetterHeadUrl" width="100%" />
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; font-weight: bold; margin: 5px">
          Quality Control Test Report
        </p>
      </div>

      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <tr>
            <th style="border: 1px solid black">Product Name</th>
            <th style="border: 1px solid black" colspan="2">Pack / PO Size</th>
            <th style="border: 1px solid black">PO No</th>
            <th style="border: 1px solid black">Product Code</th>
          </tr>
          <tr>
            <td style="border: 1px solid black">{{ qc.productName }}</td>
            <td style="border: 1px solid black" colspan="2">
              {{ qc.factorUnitName }}
            </td>
            <td style="border: 1px solid black">{{ qc.purchaseOrderNo }}</td>
            <td style="border: 1px solid black">{{ qc.productCode }}</td>
          </tr>

          <tr>
            <th style="border: 1px solid black">QC No</th>
            <th style="border: 1px solid black">Quantity</th>
            <th style="border: 1px solid black">Received Date</th>
            <th style="border: 1px solid black">Batch No/Lot No</th>
            <td style="border: 1px solid black">
              <span class="font-weight-bold">MFG : </span>
              {{ qc.mfgDateInMilliSeconds | formatMsDate }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black" rowspan="2">{{ qc.qcNo }}</td>
            <td style="border: 1px solid black" rowspan="2">{{ qc.qcQty | decFormat(6) }}</td>
            <td style="border: 1px solid black" rowspan="2">
              {{ qc.receivedDateInMilliSeconds | formatMsDate }}
            </td>
            <td style="border: 1px solid black" rowspan="2">
              {{ qc.batchLotNo }}
            </td>
            <td style="border: 1px solid black">
              <span class="font-weight-bold">EXP : </span>
              {{ qc.expDateInMilliSeconds | formatMsDate }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black">
              <span class="font-weight-bold">Origin : </span>{{ qc.origin }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black" colspan="2" rowspan="3">
              <span class="font-weight-bold">Sampling Date : </span>
              {{ qc.samplingDateInMilliSeconds | formatMsDate }}
              <br /><br />
              <span class="font-weight-bold">Test Completion Date : </span>
              {{ qc.testCompletionDateInMilliSeconds | formatMsDate }}
            </td>
            <td style="border: 1px solid black" colspan="3">
              <span class="font-weight-bold">Manufacturer : </span>
              {{ qc.manufacturer }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black" colspan="3">
              <span class="font-weight-bold">Supplier / Source : </span>
              {{ qc.supplierName }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black" colspan="3">
              <span class="font-weight-bold">Reference : </span>
              {{ qc.reference }}
            </td>
          </tr>
        </table>
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            margin-top: 20px;
          "
        >
          <thead>
            <th style="border: 1px solid black; width: 10%">No.</th>
            <th style="border: 1px solid black; width: 35%">Parameter</th>
            <th style="border: 1px solid black; width: 45%">Result</th>
          </thead>
          <tr style="height: 70px">
            <td style="border: 1px solid black"></td>
            <td style="border: 1px solid black"></td>
            <td style="border: 1px solid black"></td>
          </tr>
        </table>
        <div style="margin: 8px; font-size: 11px">
          <span class="font-weight-bold">REMARKS:</span> {{ qc.remark }}
        </div>
        <div style="margin-top: 50px">
          <div style="float: left; text-align: center; width: 20%">
            <p class="font-weight-bold">---------------</p>
            <p class="font-weight-bold">Signature</p>
          </div>
          <div style="float: right; text-align: center; width: 20%">
            <p class="font-weight-bold">---------------</p>
            <p class="font-weight-bold">Signature</p>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { qcService } from "../../services/qc-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";

export default {
  name: "QCList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "QC Management",
        disabled: true,
      },
      {
        text: "QC",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status" },
      { text: "Warehouse", value: "warehouseName" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "QC No", value: "qcNo" },
      { text: "PO No", value: "purchaseOrder.issueNo" },
      { text: "Reference", value: "reference" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    qcList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "PASS", value: "PASS" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      warehouseId: "",
      status: "",
      qcNo: "",
      poNo: "",
    },
    openDialog: false,
    buttonLoading: false,
    warehouseList: [],
    qc: {},
  }),
  watch: {
    pagination: {
      handler() {
        this.getQCList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.warehouseId = this.checkUserRole();
    this.getWarehouseList();
    
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.qcNo) {
      this.queryParams.qcNo = this.$route.query.qcNo;
    }
    if (this.$route.query.poNo) {
      this.queryParams.poNo = this.$route.query.poNo;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    checkUserRole() {
      if (this.user.role.roleName == 'BRANCH_ADMIN' || this.user.role.roleName == "WAREHOUSE_MANAGER") {
        return this.user.warehouseId;
      }
      return "";
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "qcs", query: this.queryParams });
      this.getQCList();
    },
    getQCList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      qcService
        .getQCList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.qcList = res.data.qcList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/qc/new");
    },
    onEdit(qc) {
      // go to details page
      this.$router.push("/qc/" + qc.id);
    },

    async printDetail(item, divName) {
      this.qc = { ...item };

      await this.$nextTick();

      var printContents = document.getElementById(divName).innerHTML;
      var reprintWindow = window.open("", "MsgWindow", "width=500,height=500");
      reprintWindow.document.write(printContents);
      setTimeout(() => {
        reprintWindow.print();
        reprintWindow.close();
      }, 600);
    },
  },
};
</script>
